import React, { createContext, ReactNode, useContext, useMemo } from 'react';

interface EditableTextFieldConfiguration {
  disabled?: boolean;
  requireConfirmation?: boolean;
}

interface EditableTextFieldConfigurationContextType {
  configuration: EditableTextFieldConfiguration;
}

const EditableTextFieldConfigurationContext = createContext<
  EditableTextFieldConfigurationContextType | undefined
>(undefined);

interface EditableTextFieldConfigurationProviderProps {
  children: ReactNode;
  configuration?: EditableTextFieldConfiguration;
}

export function EditableTextFieldConfigurationProvider(
  props: EditableTextFieldConfigurationProviderProps,
) {
  const { children, configuration = {} } = props;
  const value = useMemo(
    () => ({
      configuration,
    }),
    [configuration],
  );

  return (
    <EditableTextFieldConfigurationContext.Provider value={value}>
      {children}
    </EditableTextFieldConfigurationContext.Provider>
  );
}

export function useEditableTextFieldConfiguration(): EditableTextFieldConfiguration {
  const context = useContext(EditableTextFieldConfigurationContext);

  if (context === undefined) {
    // Return default configuration if no provider is found
    return {};
  }

  return context.configuration;
}
